import { render, staticRenderFns } from "./FormBuilderArea.vue?vue&type=template&id=5dc7b76b&"
import script from "./FormBuilderArea.vue?vue&type=script&lang=js&"
export * from "./FormBuilderArea.vue?vue&type=script&lang=js&"
import style0 from "./FormBuilderArea.vue?vue&type=style&index=0&id=5dc7b76b&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../Breeze.Kiosk.Frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports